import React from "react";
import { tkoData } from "./TKOData";
import TechnicalDiagram from "./TechnicalDiagram";
import "../../css/components/standardPage.css";
import "../../css/products/TKO.css";

const TKOPage = () => {
  return (
    <div className="standard-page">
      {/* Hero Section */}
      <div
        className={`page-hero ${tkoData.cardsPosition === 'bottom' ? 'cards-bottom' : ''}`}
        style={{
          backgroundImage: tkoData.content[0]?.href ? `url(${tkoData.content[0].href})` : undefined,
        }}
      >
        <div className="hero-overlay"></div>
        
        {/* Main Title */}
        <h1 className="page-title">{tkoData.title}</h1>
        <p className="page-subtitle">Turnkey Observatory</p>
        
        {/* Hero Cards - smaller cards with key points */}
        <div className="hero-cards-container">
          {tkoData.heroCards.map((card, index) => (
            <div key={index} className="hero-card">
              <h3 className="hero-card-title">{card.title}</h3>
              <p className="hero-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Content Sections */}
      <div className="content-sections">
        {tkoData.content.slice(1).map((section, index) => {
          // Special treatment for Hardware & Design section (index 0)
          if (index === 0) {
            return (
              <div key={index} className="technical-section">
                <div className="technical-background"></div>
                {section.title && <h2 className="section-title-overlay">{section.title}</h2>}
                
                <div className="technical-content">
                  <TechnicalDiagram 
                    imageSrc={section.href} 
                    markers={section.markers || []}
                  />
                </div>
              </div>
            );
          }
          
          // Regular sections for everything else
          return (
            <div
              key={index}
              className={`content-section ${section.cardsPosition === 'bottom' ? 'cards-bottom' : ''} ${section.tiltShift ? 'tilt-shift-section' : ''}`}
              style={{
                backgroundImage: section.href ? `url(${section.href})` : undefined,
              }}
            >
              <div className="section-overlay"></div>
              {section.title && <h2 className="section-title-overlay">{section.title}</h2>}
              <div className={`section-cards-container ${section.cards.length === 2 ? 'two-cards' : section.cards.length === 3 ? 'three-cards' : ''}`}>
                {section.cards.map((card, cardIndex) => (
                  <div key={cardIndex} className="section-card tko-card">
                    {card.icon && (
                      <div className="tko-card-icon">
                        <img src={card.icon} alt={card.title} />
                      </div>
                    )}
                    {card.title && <h3 className="tko-card-title">{card.title}</h3>}
                    <p className="section-card-description">{card.description}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TKOPage;

